import * as React from 'react';
import './SynonymManager.scss';
import Modal from 'src/components/common/Modal';
import synonymServiceInstance from 'src/services/synonym/synonymService';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import {
  goToHome
} from 'src/utils/navigation';
import { withWidth } from '@material-ui/core';

interface ISynonymProps {
  t?: any;
  isLoggedIn: boolean;
}

const SynonymManager: React.FC<ISynonymProps> = props => {
  const [synonyms, setSynonyms] = React.useState({});
  const [termEdit, setTerm] = React.useState("");
  const [newSynonyms, setNewSynonyms] = React.useState([{ currentTerm: "", currentSynonyms: "" }]);
  const [editingTerm, setEditingTerm] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [errorMessage,setErrorMessage] = React.useState("");
  const [validAccess, setIsValidAccess] = React.useState(true);
  const [searchInput,setSearchInput] = React.useState("");


  const fetchAll = () => {
    return synonymServiceInstance.getSynonym().then(list => {
      setSynonyms(list);
   });
  };

  const handleEdit = async (term: string) => {
    try {
      const existing = await synonymServiceInstance.fetchSynonymByTerm(term);
      setIsModalOpen(true);
      setEditingTerm(term);
      setNewSynonyms([{ currentTerm: term, currentSynonyms: existing }]);
    } catch (error) {
      console.log(error);
    }
  };


  const handleAdd = async () => {
    for (const { currentTerm, currentSynonyms } of newSynonyms) {

        const term1 = currentTerm.trim();
        const synonymArray = currentSynonyms.split(",").map((s) => s.trim()).filter((s) => s !== "");

        const alreadyExists = Object.entries(synonyms).some(([key, values]) => term1 === key);
        

        if(alreadyExists){
          setErrorMessage('Synonyms exist for the term.');
          return;
        }

        if(!currentTerm || term1.length <= 0){
          setErrorMessage('Search term cannot be empty.');
          return;
      }

      if(!currentSynonyms || synonymArray.length <= 0){
        setErrorMessage('Synonym cannot be empty.');
        return;
      }
      if(!synonymArray.some((s) => s !== term1)){
        setErrorMessage('At least one synonym must be different from the search term.');
        return;
      }
}
// Build payload object
const payload = newSynonyms.reduce((acc: { [key: string]: string[] }, { currentTerm, currentSynonyms }) => {
  const synonymsArray = currentSynonyms
    .split(",")
    .map(s => s.trim())
    .filter(s => s !== "");
    
  if (currentTerm.trim() !== "" && synonymsArray.length > 0) {
    acc[currentTerm.trim()] = synonymsArray;
  }
  return acc;
}, {});

    await synonymServiceInstance
    .addSynonym(payload)
    .then(response => {
      setTerm("");
      setNewSynonyms([]);
      setErrorMessage('');
      setIsModalOpen(false);
      fetchAll();
    }).catch(error => {
      console.log(error);
    }); 
  };


  const handleDelete = async (term:any) => {
    await synonymServiceInstance
    .deleteSynonymByTerm(term)
    .then(response => {
      fetchAll();
    }).catch(error => {
      console.log(error);
    });
  };

  const handleUpdate = async () => {
    const { currentTerm, currentSynonyms } = newSynonyms[0];
    const updatedSynonyms = currentSynonyms.split(",").map((s) => s.trim()).filter((s) => s !== "");

    if(!updatedSynonyms || updatedSynonyms.length <= 0){
      setErrorMessage('Synonym cannot be empty.');
      return;
  }
  if(!updatedSynonyms.some((s) => s !== editingTerm)){
      setErrorMessage('At least one synonym must be different from the search term.');
      return;
  }

    const keyName = editingTerm;
    const requestBody = {
      [keyName]: updatedSynonyms
    };

    await synonymServiceInstance
    .addSynonym(requestBody)
    .then(response => {
      setEditingTerm(null);
      setNewSynonyms([]);
      setIsModalOpen(false);
      setErrorMessage('');
      fetchAll();
    }).catch(error => {
      console.log(error);
    }); 
  };

   
  const closeModal = () => setIsModalOpen(false);

  const modalStyles = {
    background: 'white',
    padding: '20px',
    width: '700px',
    position: 'relative',
    outline: 'none',
    borderRadius:10,
    height: '20% !important'
  };

  React.useEffect(() => {
    if (window.location.hash === '#/solr/synonymmanager') {
      if (window === window.top) {
        // Not inside an iframe → redirect to homepage or error page
        goToHome();
      }else{
        fetchAll();
      }
    }
  }, []); 
 
  return (
    <div>
    { validAccess===true ? (  
    <div className="max-w-6xl mx-auto py-10 px-8 w-full synonym">

        <div className="search-bar">
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    className="form-input w-full border border-gray-300 rounded px-4 py-2"
                  />
                </div>
        
                <div>
                  {/* Add Button */}

                  <button
                    onClick={() =>{
                        setIsModalOpen(true);
                        setEditingTerm("");
                        setNewSynonyms([{ currentTerm: "", currentSynonyms: "" }])
                        }}
                    className="full-width w-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded mb-6"
                    style={{ width: '105px', height: '40px' }}
                  >
                    + Add New
                  </button>
              </div>
        </div>
       
        {/* Synonym List */}
        <div className="grid grid-cols-1 gap-4 mt-2">
          {synonyms && Object.entries(synonyms) .filter(
          ([term, values]) =>
            term.toLowerCase().includes(searchInput.toLowerCase()) ||
            (Array.isArray(values) &&
              values.some((val: string) =>
                val.toLowerCase().includes(searchInput.toLowerCase())
              ))
        ).map(([term, values]) => (

            <div className="synonym-item" key={term}>
              <div className="term-values">
                <strong className="fixed-label">{term}:</strong>{" "}
                <span className="value-list">


                {values && (values as any[]).map((item,i) => (
                  <span key={i} className="value-chip">
                  {item}
                </span>
                ))}
                </span>
              </div>
              <div className="button-group">
              <EditIcon
                  onClick={() => handleEdit(term)}
                    className="edit-btn"
                />
                <DeleteIcon
                  onClick={() => handleDelete(term)}
                    className="delete-btn"
                />
              </div>
            </div>
          ))}
        </div>

          {/* Modal */}
          {isModalOpen && (
          <Modal
            showClose={isModalOpen}
            handleCloseModal={closeModal}
            styles={modalStyles}
          >
            {/* Header */}
            <div className="modal-header">
              <h2 className="modal-title">
                {editingTerm
                  ? `Edit Synonyms`
                  : "Add New Synonym"}
              </h2>
              <button className="modal-close"
                onClick={() => {
                                  closeModal();
                                  setTerm("");
                                  setNewSynonyms([]);
                                  setErrorMessage('');
                                }}
              >
              
                X
              </button>
            </div>

            <hr className="modal-divider" />

            {/* Body */}
            <div className="modal-body">
              {!editingTerm &&
                newSynonyms.map((item, index) => (
                  <div className="form-row mb-2" key={index}>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Search term"
                        value={item.currentTerm}
                        onChange={(e) => {
                          const updated = [...newSynonyms];
                          updated[index].currentTerm = e.target.value;
                          setNewSynonyms(updated);
                        }}
                        className="form-input"
                      />
                    </div>

                    <div className="arrow-wrapper">
                      <span className="arrow">→</span>
                    </div>

                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Synonyms"
                        value={item.currentSynonyms}
                        onChange={(e) => {
                          const updated = [...newSynonyms];
                          updated[index].currentSynonyms = e.target.value;
                          setNewSynonyms(updated);
                        }}
                        className="form-input"
                      />
                    </div>

                    {newSynonyms.length > 1 && (
                      <button
                        className="ml-2 text-red-600"
                        onClick={() => {
                          const updated = newSynonyms.filter((_, i) => i !== index);
                          setNewSynonyms(updated);
                        }}
                      >
                         X
                      </button>
                    )}
                  </div>
                ))}

              {/* Add more synonyms */}
              {!editingTerm && (
                <div className="mt-2">
                  <button
                    onClick={() =>
                      setNewSynonyms([...newSynonyms, { currentTerm: "", currentSynonyms: "" }])
                    }
                    className="text-blue-600 hover:underline"
                  >
                    + Add another
                  </button>
                </div>
              )}

              {/* Edit Mode Single row */}
              {editingTerm && (
                <div className="form-row">
                  <div className="input-wrapper">
                    <input
                      type="text"
                      placeholder="Search term"
                      value={editingTerm}
                      className="form-input"
                      disabled={true}
                    />
                  </div>

                  <div className="arrow-wrapper">
                    <span className="arrow">→</span>
                  </div>

                  <div className="input-wrapper">
                    <input
                      type="text"
                      placeholder="Synonyms"
                      value={newSynonyms.length>0 ?  newSynonyms[0].currentSynonyms : ''}
                      onChange={(e) => {
                        const updated = [...newSynonyms];
                        updated[0].currentSynonyms = e.target.value;
                        setNewSynonyms(updated);
                      }}
                      className="form-input"
                    />
                  </div>
                </div>
              )}
            </div>

            <hr className="modal-divider" />
            {errorMessage && <p style={{ color: 'red', fontSize: '14px' }}>{errorMessage}</p>}
            {/* Footer */}
            <div className="modal-footer">
              <button
                className="modal-btn cancel-btn"
                onClick={() => {
                  closeModal();
                  setTerm("");
                  setNewSynonyms([]);
                  setErrorMessage('');
                }}
              >
                Cancel
              </button>
              <button
                className="modal-btn add-btn"
                onClick={() => {
                  if (editingTerm) {
                    handleUpdate();
                  } else {
                    handleAdd();
                  }
                }}
              >
                {editingTerm ? "Update" : "Add"}
              </button>
            </div>
          </Modal>
        )}

    </div>
    ):
    <div className="max-w-6xl mx-auto py-10 px-8 w-full synonym">
      <p style={{ color: 'red', fontSize: '25px' }}>Access denied.</p>
    </div>
    } 
    </div>
  );
};

export default SynonymManager;
